import { memo, useEffect, useImperativeHandle, useRef, useState } from "react"
import ButtonGradientPr from "../buttonGradientPr";

import Portal from "../portal";
import classNames from "classnames";
import { getAuthMobileCodeAPI, submitMobileCodeAPI, submitUserInfoAPI, getRiskVerifyAPI } from "@/apis/user";
import { toast } from "../modals";
import { getCharLength } from "@/utils";
import { pageScrollHide } from "@/utils/base";

// import Cookies from 'js-cookie';
import { UploadImageCrop } from "../uploadImageCrop";
import user from "@/utils/user";

import "./index.scss";

import dataCapture from '@/utils/dataCapture';

// const setCookie = (key, value) => {
//     Cookies.set(key, value);
// }

let login = {};
let mobileNumber;
const LoginDom = () => {

    const [mobile, setMobile] = useState('');
    const [smsCode, setSmsCode] = useState('');
    const [invitationCode, setInvitationCode] = useState('');
    const [agree, setAgree] = useState(false);
    const [errList, setErrList] = useState([]);

    const [hasInvitation, setHasInvitation] = useState(false);
    const [smsSecond, setSmsSecond] = useState(0);
    const [smsDelay, setSmsDelay] = useState(false);
    const [isNew, setIsNew] = useState(true);
    useEffect(() => {
        var timer;
        if (smsDelay) {
            setSmsSecond(60);
            timer = setInterval(() => {
                setSmsSecond(seconds => {
                    if (seconds < 2) {
                        setSmsDelay(false);
                    } else {
                        return seconds - 1;
                    }
                })
            }, 1000);
        } else {
            clearInterval(timer);
        }
        return () => {
            clearInterval(timer);
        }
    }, [smsDelay])

    const getSmsCode = async (captchaVerifyParam) => {
        if (smsDelay) return;
        if (!/^\d{11}$/.test(mobileNumber)) {
            setErrList(['请输入正确的手机号'])
        } else {
            setSmsDelay(true);
            setErrList([]);

            try {
                const rs = await getAuthMobileCodeAPI({
                    captchaVerifyParam,
                    mobile: mobileNumber,
                    invitecode: invitationCode
                });
                if (rs.retcode === 100) {
                    toast.show(rs.message.msg, 3000);
                    setIsNew(rs.message.isNew === 1)
                } else if (rs.retcode === 206) {
                    setSmsDelay(false);
                    toast.show(rs.errmsg);
                    setHasInvitation(true);
                }
                else if (rs.retcode === 208) {
                    document.getElementById('captcha-button').click();
                }
                else {
                    setSmsDelay(false);
                    toast.show(rs.errmsg);
                    setErrList([rs.errmsg]);
                }
                return rs;
            } catch (err) {
                console.log(err);
            }

        }
    };

    const validate = () => {
        setErrList([]);
        const _err = [];
        if (mobile === '' || !/^\d{11}$/.test(mobile)) _err.push('请输入正确的手机号');
        if (smsCode === '') _err.push('请输入验证码');
        if (!agree) _err.push('请阅读并同意《用户协议》和《隐私政策》');
        setErrList(_err);
        return _err.length < 1
    }
    const onSubmit = async (_isNew) => {

        if (validate()) {
            try {
                const rs = await submitMobileCodeAPI({
                    mobile,
                    code: smsCode
                });

                if (rs.retcode === 100) {
                    const { isNew: _isNew, token } = rs.message;

                    if (_isNew) {
                        dataCapture.sendData('click', undefined, 'sign', '', {});

                        localStorage.setItem("_TOKEN", rs.message.token);
                        login.showUserInfoSet();
                    } else {
                        dataCapture.sendData('click', undefined, 'login', '', {});

                        localStorage.removeItem("_TOKEN");
                        // toast.show('登录成功');
                        // //临时前端自己种cookie
                        // setCookie('token', token);
                        // setCookie('uinfo', '11111|用户名|https://vi1.6rooms.com/live/2023/09/04/20/1003v1693829702496079781.jpg');
                        // setCookie('vipinfo', '1|3232');
                        // 拉取用户详细信息, 网页端直接读cookie
                        // getMyInfoAPI().then()
                        // localStorage.removeItem('_TOKEN');
                        user.token = token;
                        user.updateInfo().then(() => {
                            // setTimeout(() => {
                            //     window.location.reload();
                            // }, 1000);
                            window.location.reload();
                        });
                    }
                } else {
                    setErrList([rs.errmsg])
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    let captcha;

    const getInstance = (instance) => {
        captcha = instance;
    };

    const captchaVerifyCallback = async (captchaVerifyParam) => {
        // 1.向后端发起业务请求，获取验证码验证结果和业务结果
        const res = await riskVerify('', captchaVerifyParam);
        if (res) {
            return {
                captchaResult: true, // 验证码验证是否通过，boolean类型，必选
                bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
            }
        }
        else {
            return {
                captchaResult: false, // 验证码验证是否通过，boolean类型，必选
                bizResult: false, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
                bizResultMsg: res.errmsg, // 业务验证不通过时的错误提示信息，可选
            }
        };

    }
    // 验证通过后调用
    const onBizResultCallback = () => {
        console.log('onBizResultCallback');
    }

    useEffect(() => {
        window.initAliyunCaptcha({
            SceneId: '1l357dko', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
            prefix: 't9am40', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
            mode: 'popup', //embed 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
            element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
            button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
            captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
            onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
            getInstance: getInstance, // 绑定验证码实例函数，无需修改
            slideStyle: {
                width: 360,
                height: 40,
            }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
            language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        });
        return () => {
            // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
            document.getElementById('aliyunCaptcha-mask')?.remove();
            document.getElementById('aliyunCaptcha-window-popup')?.remove();
        }
    }, []);

    // 验证
    const riskVerify = async (e, captchaVerifyParam) => {
        try {
            const res = await getRiskVerifyAPI({
                mobile: Number(mobileNumber),
                sceneid: '1l357dko',
                code: captchaVerifyParam,
            });
            if (res.retcode === 100 || res.retcode === 200) {
                getSmsCode();
                return true;
            } else if (res.retcode === 208) {
                document.getElementById('captcha-button').click(); //触发验证码
                return false;
            } else if (res.retcode === 402) {
                toast.show(res.errmsg);
                return true;
            }
            else {
                toast.show(res.errmsg);
                return false;
            }
        } catch (err) {
            console.log(err);
        }

    }
    return (
        <div className="login-panel">
            <div className="login-panel-close" onClick={login.hide}></div>
            <div className="lp-header"><span></span></div>
            <div className="login-panel-container">
                <div className="lb-form">
                    <div className="mobile-id"><input type="tel" pattern="\d{11}" required onChange={(e) => { setMobile(e.target.value); mobileNumber = e.target.value }} value={mobile} name="mobile_id" placeholder="请输入手机号" /></div>
                    <div className={classNames("invitation-code", hasInvitation && "invitation-code-v")}>
                        <input type="texst" value={invitationCode} pattern="[\w]{5,}" onChange={(e) => setInvitationCode(e.target.value)} name="invitation_code" placeholder="请输入邀请码" />
                    </div>
                    <div className="sms-code">
                        <input type="text" value={smsCode} pattern="[\w\d]{4}" required onChange={(e) => setSmsCode(e.target.value)} name="sms_code" placeholder="请输入验证码" />
                        <span className={classNames(smsDelay && "disabled")} onClick={riskVerify}>
                            {smsDelay ? `${smsSecond}s` : '获取验证码'}
                        </span>
                    </div>
                    <div style={{ height: errList.length * 22 }} className={classNames("err-info", errList.length > 0 && "err-info-v")}>
                        {errList.map((item, i) => <span key={i}>{item}</span>)}
                    </div>
                    <div className="agreement">
                        <input type="checkbox" onChange={(inp) => {
                            setAgree(inp.target.checked);
                        }} name="agreement" id="agre__input" />
                        <label htmlFor="agre__input">请阅读并同意</label><a href="/about/policy/cc1" target="_blank">《用户协议》</a>和<a href="/about/policy/cc2" target="_blank">《隐私政策》</a>
                    </div>
                </div>
                <div className="handler">
                    <ButtonGradientPr style={{ height: 48, width: 120 }} onClick={() => onSubmit(isNew)}>
                        {/* {isNew ? '下一步' : '登录'} */}登录/注册
                    </ButtonGradientPr>
                </div>
            </div>
        </div>
    )
};

const UserInfoDom = () => {
    const [avatarUrl, setAvatarUrl] = useState('');
    const [imgUploadPercent, setImgUploadPercent] = useState(0);
    const [name, setName] = useState('');
    const [count, setCount] = useState(0);
    const [err, setErr] = useState('');

    // const setUrl = (url) => {
    //     setAvatarUrl(url);
    // }
    const onInputName = (inp) => {
        const val = inp.target.value.replace(/\s/g, '');
        setName(val);
        setCount(Math.floor(getCharLength(val) / 2));
    }
    const onSubmit = async () => {
        setErr('');
        if (name === '') {
            setErr('昵称不能为空');
        } else if (!/^[\u4E00-\u9FA5\w-]+$/.test(name)) {
            setErr('仅支持中英文、数字、下划线、减号');
        } else if (Math.floor(getCharLength(name) / 2) > 16) {
            setErr('昵称最多16个字符');
        } else {
            try {
                const rs = await submitUserInfoAPI({
                    headurl: avatarUrl,
                    nickname: name
                });

                if (rs.retcode === 100) {
                    localStorage.removeItem("_TOKEN");
                    // toast.show('登录成功');
                    // const {token, userinfo } = rs.message;
                    //临时前端自己种cookie
                    // setCookie('token', tempToken);
                    // setCookie('uinfo', '11111|用户名|https://vi1.6rooms.com/live/2023/09/04/20/1003v1693829702496079781.jpg');
                    // setCookie('vipinfo', '1|3232');
                    // 拉取用户详细信息, 网页端直接读cookie
                    // getMyInfoAPI().then()
                    const { token } = rs.message;
                    user.token = token;
                    user.updateInfo().then(rs => {
                        // setTimeout(() => {
                        window.location.reload();
                        // }, 1000);
                    });

                } else {
                    toast.show(rs.errmsg);
                    setErr(rs.erromsg);
                }
            } catch (err) {
                console.log(err);
                setErr('网络异常');
            }
        }
    };


    return (
        <div className="login-sec">
            <div className="ls-header">
                <div className="avatar">
                    <span className={classNames("img-upload-percent", (imgUploadPercent > 0 && imgUploadPercent < 100) && "img-upload-percent-v")}>{imgUploadPercent}%</span>
                    <UploadImageCrop
                        className="input-file"
                        accept="image/*"
                        saveSize={{ width: 800, height: 800 }}
                        selectSize={{ width: 800, height: 800 }}
                        setUrl={setAvatarUrl}
                        setPercent={setImgUploadPercent}
                    />
                    {!!avatarUrl ? <img src={avatarUrl} /> : <span className="img-btn"></span>}
                </div>
            </div>
            <div className="login-sec-">
                <div className="ls-form">
                    <div className="user-name">
                        <input type="text" pattern="[\u4E00-\u9FA5\w\-]{3,}" required onChange={onInputName} value={name} placeholder="请输用户名" />
                        <span>{count}/16</span>
                    </div>
                    <div className={classNames("err-info", err !== '' && "err-info-v")}>{err}</div>
                </div>
                <div className="handler">
                    <ButtonGradientPr styles={{ height: 48, width: 120 }} onClick={onSubmit}>确定</ButtonGradientPr>
                </div>
            </div>
        </div>
    )
};

const Login = memo((props) => {
    // let { visible: visible, setVisible} = props;

    const [visible, setVisible] = useState(false);
    const [show, setShow] = useState(false);
    const [showLogin, setShowLogin] = useState(true);
    // const [tempToken, setTempToken] = useState('');

    const loginRef = useRef(null);

    useImperativeHandle(loginRef, () => {
        return {
            show() {
                setTimeout(() => {
                    setVisible(true)
                }, 0)
                pageScrollHide(1);
                return setShow(true);
            },
            hide() {
                setTimeout(() => {
                    setShow(false);
                }, 300)
                pageScrollHide(0);
                return setVisible(false);
            },
            showUserInfoSet() {
                // setTempToken();
                return setShowLogin(false);
            }
        }
    });
    useEffect(() => {
        login = loginRef.current;
        return () => {
            login?.hide();
        }
    }, [])

    return (
        show &&
        <Portal>
            <div className={classNames("login-panel-wrapper", visible && "login-panel-wrapper-v")}>
                {showLogin ? <LoginDom /> : <UserInfoDom />}
            </div>
        </Portal>
    )
});

export {
    Login,
    login
};